<template>
    <div :class="['ReviewHeader', compact && 'ReviewHeader--compact']">
        <span :class="statusClass"></span>
        <div class="ReviewHeader__content">
            <div class="ReviewHeader__header">
                <span>{{ reviewId }}</span>
                <span class="ReviewHeader__location-name">{{ location.display_name }}</span>
                <span class="ReviewHeader__address">{{ addressName }}</span>
            </div>

            <div
                class="ReviewHeader__actions-container"
                @click.stop=""
            >
                <span
                    class="ReviewHeader__header-action"
                    @click="$emit('flag', reviewId)"
                >
                    <StreamlineIcon
                        :icon="flagIcon"
                        name="placeholder"
                        :stroke="flagColor"
                        :size="16"
                    />
                </span>
                <RPHorizontalMenu>
                    <HeaderDropdown
                        @share="$emit('share')"
                        @request="$emit('request')"
                        @open-review="$emit('open-review')"
                    />
                </RPHorizontalMenu>
            </div>
        </div>
    </div>
</template>
<script>
import RPHorizontalMenu from 'components/Basic/Buttons/RPHorizontalMenu.vue';
import HeaderDropdown from './HeaderDropdown.vue';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {Flag1} from '@reviewpush/streamline-regular/lib/social-medias-rewards-rating/Flags';
import colors from 'style/_colors.scss';
import statusBuilder from 'status/statusBuilder';
import stat from 'status/index';

export default {
    name: 'Header',
    components: {
        StreamlineIcon,
        RPHorizontalMenu,
        HeaderDropdown
    },
    props: {
        reviewId: {
            type: [String, Number],
            required: true,
        },
        location: {
            type: Object,
            required: true,
        },
        compact: {
            type: Boolean,
            default: false
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    data(){
        return {
            flagIcon: Flag1,
            flagColor: colors.textGrey,
        };
    },
    computed: {
        addressName(){
            let loc = this.location.city;
            if(this.location.state !== '') {
                loc = `${loc}, ${this.location.state}`;
            }
            if(this.location.zip !== '') {
                loc = `${loc} ${this.location.zip}`;
            }
            return loc;
        },
        headerClass(){
            return statusBuilder(
                'ReviewHeader',
                this.compact ? stat.STANDBY : this.status
            );
        },
        statusClass(){
            return statusBuilder(
                'ReviewHeader__status',
                this.compact ? stat.STANDBY : this.status,
            );
        }
    },
};
</script>
<style lang="scss">
.ReviewHeader {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    border-bottom: 1px solid $grey-75;

    &--compact { border-top-left-radius: 0; }

    &__status {
        display: block;
        height: 0.25rem;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;

        &--saving { background-image: $gradient-purple; }
        &--success { background-image: $gradient-positive; }
        &--warning { background-image: $gradient-yellow; }
        &--error { background-image: $gradient-negative; }
    }

    &__content {
        padding: 0.5rem 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: $text-grey;
    }
    &__header {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    &__location-name {
        margin: 0 0.5rem;
        font-weight: 600;
        white-space: nowrap;
    }
    &__address {
        color: $text-grey;
        white-space: nowrap;
    }
    &__actions-container {
        margin-left: 1rem;
        position: relative;
        display: flex;
        align-items: center;
        color: $text-grey;
    }
    &__header-action {
        cursor: pointer;
        height: 1rem;
        width: 1rem;
        margin-top: auto;
        margin-bottom: auto;
        &:first-child{ margin-right:1rem; }
    }
}
</style>
